import { render, staticRenderFns } from "./produceCell.vue?vue&type=template&id=4225e252"
import script from "./produceCell.vue?vue&type=script&lang=js"
export * from "./produceCell.vue?vue&type=script&lang=js"
import style0 from "./produceCell.vue?vue&type=style&index=0&id=4225e252&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports